import { render, staticRenderFns } from "./BaseHistoryNav.vue?vue&type=template&id=7cabf3ee&scoped=true"
import script from "./BaseHistoryNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseHistoryNav.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseHistoryNav.vue?vue&type=style&index=0&id=7cabf3ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cabf3ee",
  null
  
)

export default component.exports